import { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useGameStore } from '../stores/gameStore';
import { useWebSocket } from '../hooks/useWebSocket';
import Lobby from '../components/Lobby';
import Submission from '../components/Submission';
import Voting from '../components/Voting';
import Results from '../components/Results';
import GameEnd from '../components/GameEnd';
function GamePage() {
  const { code } = useParams<{ code: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { connect, send, disconnect } = useWebSocket();

  const phase = useGameStore((s) => s.phase);
  const connected = useGameStore((s) => s.connected);
  const error = useGameStore((s) => s.error);
  const reset = useGameStore((s) => s.reset);

  const playerId = searchParams.get('playerId');
  const isHost = searchParams.get('host') === '1';

  useEffect(() => {
    if (!code || !playerId) {
      navigate('/');
      return;
    }

    connect(code, playerId, isHost);

    return () => {
      disconnect();
    };
  }, [code, playerId, isHost]);

  const handleLeave = () => {
    send({ type: 'leave' });
    disconnect();
    reset();
    navigate('/');
  };

  const handlePlayAgain = () => {
    // Navigate back to create page to start a new game
    disconnect();
    reset();
    navigate('/create');
  };

  if (!connected) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-100">
        <div className="text-center">
          <span className="loading loading-ring loading-lg text-primary" />
          <p className="mt-4 text-base-content/60">Connecting...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-base-100">
      {error && (
        <div className="toast toast-top toast-center z-50">
          <div className="alert alert-error">
            <span>{error}</span>
          </div>
        </div>
      )}

      {phase === 'lobby' && (
        <Lobby
          sessionCode={code || ''}
          onStart={(config) => send({ type: 'start_game', config })}
          onLeave={handleLeave}
          send={send}
        />
      )}
      {phase === 'submission' && <Submission send={send} />}
      {(phase === 'vote_boring' || phase === 'vote_exciting') && <Voting send={send} />}
      {phase === 'result' && <Results />}
      {phase === 'game_end' && <GameEnd onPlayAgain={handlePlayAgain} onExit={handleLeave} />}
    </div>
  );
}

export default GamePage;
